/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_CurrentInputs */

const en_plan_current = /** @type {(inputs: Plan_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Plan`)
};

const es_plan_current = /** @type {(inputs: Plan_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan actual`)
};

/**
* | output |
* | --- |
* | "Current Plan" |
*
* @param {Plan_CurrentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_current = /** @type {((inputs?: Plan_CurrentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_CurrentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_current(inputs)
	return en_plan_current(inputs)
});